import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

const inlineLoadingRecipe = defineSlotRecipe({
  className: 'inline-loading',
  slots: ['root', 'label'],
  base: {
    root: {
      alignItems: 'center',
      display: 'flex',
      gap: '8',
    },
    label: {},
  },
  variants: {
    size: {
      sm: {
        label: { textStyle: 'body/sm/regular' },
      },
      md: {
        label: { textStyle: 'body/md/regular' },
      },
      lg: {
        label: { textStyle: 'body/lg/regular' },
      },
    },
    status: {
      error: {},
      loading: {
        root: { color: 'text/secondary' },
      },
      success: {},
    },
  },
  defaultVariants: {
    size: 'md',
    status: 'loading',
  },
});

export default inlineLoadingRecipe;
